import { TableHeaderData } from "../../../../investorOverview/types";

const orderSummaryTableHeaderData: TableHeaderData[] = [
    {
        id: 'product',
        label: 'PRODUCT',
        align: 'left',
        isSortable: true,
    },
    {
        id: 'ordersPlaced',
        label: 'PLACED',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderApproved',
        label: 'APPROVED',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderRejected',
        label: 'REJECTED',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'setttlement',
        label: 'SETTLEMENT COMPLETED',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'settlementPending',
        label: 'SETTLEMENT PENDING',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'settlementNotRequired',
        label: 'SETTLEMENT NOT REQUIRED',
        align: 'center',
        isSortable: true,
    },
]

const orderHistoryTableHeaderData: TableHeaderData[] = [
    {
        id: 'clientName',
        label: 'CLIENT NAME',
        align: 'left',
        isSortable: true,
    },
    {
        id: 'clientCode',
        label: 'CLIENT CODE',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'accountType',
        label: 'ACCOUNT TYPE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'investorType',
        label: 'INVESTOR TYPE',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'modeOfHolding',
        label: 'MODE OF HOLDING',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'productType',
        label: 'PRODUCT TYPE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderNumber',
        label: 'ORDER ID',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderDate',
        label: 'ORDER DATE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderAmount',
        label: 'ORDER AMOUNT',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'transactionType',
        label: 'TRANSACTION TYPE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'approvalStatus',
        label: 'ORDER STATUS',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'paymentStatus',
        label: 'PAYMENT STATUS',
        align: 'center',
        isSortable: true,
    },
    {
        id: '',
        label: '',
        align: 'center',
        isSortable: false,
    },
]

const ordersPlacedTableHeaderData: TableHeaderData[] = [
    {
        id: 'clientName',
        label: 'CLIENT NAME',
        align: 'left',
        isSortable: true,
    },
    {
        id: 'clientCode',
        label: 'CLIENT CODE',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'accountType',
        label: 'ACCOUNT TYPE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'investorType',
        label: 'INVESTOR TYPE',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'modeOfHolding',
        label: 'MODE OF HOLDING',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'productType',
        label: 'PRODUCT TYPE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderNumber',
        label: 'ORDER ID',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderDate',
        label: 'ORDER DATE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'orderAmount',
        label: 'ORDER AMOUNT',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'transactionType',
        label: 'TRANSACTION TYPE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'approvalStatus',
        label: 'ORDER STATUS',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'paymentStatus',
        label: 'PAYMENT STATUS',
        align: 'center',
        isSortable: true,
    },
]

export { orderSummaryTableHeaderData, orderHistoryTableHeaderData, ordersPlacedTableHeaderData } 